import AccordionItem from "./accordionItemEntity";
import BreadcrumbsPath from "./breadcrumbsPathEntity";
import LinkItem from "./linkItemEntity";

export default class ContentPage {
    public id: string;
    public title: string;
    public heroImage: string;
    public content: string;
    public accordionItems: AccordionItem[];
    public linkItems: LinkItem[];
    public breadcrumbsPath: BreadcrumbsPath;
    
    constructor() {
      this.id = "";
      this.title = "";
      this.heroImage = "";
      this.content = "";

      this.accordionItems = [];
      this.linkItems = [];

      this.breadcrumbsPath = new BreadcrumbsPath();
    }

    public get isEmpty(): boolean {
      return this.id === '';
    }
  }


// WEBPACK FOOTER //
// ./src/api/contentPageEntity.ts